// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"87f0786a","498":"e56dbc00","703":"e2ffc4a0","787":"4699d67a"}[chunkId] + ".chunk.js";
};